<p class="symptom">
  {{ 'symptomAssessment.selectedSymptom' | translate }}<span>{{ symptomSelected.label }}</span>
</p>
<form [formGroup]="questionnaireForm">
  @for (question of questions; track question; let i = $index) {
    <div class="question-container">
      @if (!question.symptom?.label) {
        <p class="label">{{ question.category || '' }} {{ question.label }}</p>
      }
      @if (question.symptom?.label) {
        <p class="label">{{ question.category || '' }} {{ question.symptom?.label ? '(' + question.symptom.label + ')' : '' }}</p>
      }
      @if (question.questions) {
        <div>
          @for (subQuestion of question.questions; track subQuestion; let j = $index) {
            <nz-form-item>
              <p class="label">
                {{ subQuestion.label }}
                @if (subQuestion.tooltip) {
                  <span nz-tooltip class="tooltip" nzTooltipTitle="{{ subQuestion.tooltip }}">
                    <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                  </span>
                }
              </p>
              @if (subQuestion.multiple) {
                @for (answer of subQuestion.answers; track answer) {
                  <div class="checkbox-option">
                    <nz-form-control>
                      <label nz-checkbox [formControl]="getFormControl('question_' + i + '_' + j, answer.code)">
                        {{ answer.label }}
                      </label>
                      @if (answer.tooltip) {
                        <span nz-tooltip class="tooltip" nzTooltipTitle="{{ answer.tooltip }}">
                          <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                        </span>
                      }
                    </nz-form-control>
                  </div>
                }
              } @else {
                <nz-radio-group formControlName="question_{{ i }}_{{ j }}" class="radio-group">
                  @for (answer of subQuestion.answers; track answer) {
                    <label nz-radio [nzValue]="answer.code">
                      {{ answer.label }}
                      @if (answer.tooltip) {
                        <span nz-tooltip class="tooltip" nzTooltipTitle="{{ answer.tooltip }}">
                          <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                        </span>
                      }
                    </label>
                  }
                </nz-radio-group>
              }
            </nz-form-item>
          }
        </div>
      }
      @if (!question.questions && question.answers) {
        <div>
          @if (question.multiple) {
            @for (answer of question.answers; track answer) {
              <nz-form-item>
                <nz-form-control>
                  <label nz-checkbox [formControl]="getFormControl('question_' + i, answer.code)">
                    {{ answer.label }}
                  </label>
                  @if (answer.tooltip) {
                    <span nz-tooltip class="tooltip" nzTooltipTitle="{{ answer.tooltip }}">
                      <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                    </span>
                  }
                </nz-form-control>
              </nz-form-item>
            }
          } @else {
            <nz-radio-group formControlName="question_{{ i }}" class="radio-group">
              @for (answer of question.answers; track answer) {
                <label nz-radio [nzValue]="answer.code">
                  {{ answer.label }}
                  @if (answer.tooltip) {
                    <span nz-tooltip class="tooltip" nzTooltipTitle="{{ answer.tooltip }}">
                      <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                    </span>
                  }
                </label>
              }
            </nz-radio-group>
          }
        </div>
      }
    </div>
  }
</form>
